// extracted by mini-css-extract-plugin
module.exports = {"spin":"spin_spin__q8e2E","spin-center":"spin_spin-center__2ZtMQ"};